var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "about" } }, [
    _c("div", { staticClass: "banner" }),
    _c("div", { staticClass: "about-main" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("h1", [_vm._v("关于易安捷")]),
          _c("P", [
            _vm._v(
              "易安捷主要从事电商平台搭建，提供电商解决方案和电商相关服务，研发SaaS系统及前端商城，为客户提供便捷的一体化电商管理流程，解决电商公司客户管理难、仓库混乱、员工职责不明及财务不清等问题。SaaS产品集成HRM、CRM、FMS、OMS、WMS等各类系统，为用户开发提供更多针对性的产品和服务，在企业市场营销和促销、采购和自有品牌、供应链及全渠道流程管理上提供创新性的体验和服务，产品云端部署，整合云端过剩资源，面向用户共享资源，基于开放式、可配置的数字化平台，快速构建公司业务流程，实现企业数字化转型，让企业运营更高效、更快速、更简单。"
            )
          ])
        ],
        1
      )
    ]),
    _c("div", { staticClass: "jiazhi" }, [
      _c("div", { staticClass: "about-main" }, [
        _c("div", { staticClass: "container" }, [
          _c("h1", [_vm._v("核心价值观")]),
          _c(
            "div",
            { staticClass: " new-list" },
            _vm._l(_vm.newList, function(item, key) {
              return _c("div", { key: key, staticClass: "item" }, [
                _c("img", { attrs: { src: item.icon, alt: "" } }),
                _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
                _c("p", { staticClass: "con" }, [_vm._v(_vm._s(item.value))])
              ])
            }),
            0
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "about-main" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v("联系我们")]),
        _c("div", { staticClass: "sectionA" }, [
          _c("img", {
            attrs: { src: require("static/images/trait/lxwm.png"), alt: "" }
          }),
          _c(
            "div",
            [
              _c("P", { staticClass: "about-title" }, [_vm._v("工作时间：")]),
              _c("p", { staticClass: "time" }, [
                _vm._v("周一至周五：9:00-21:00")
              ]),
              _c("p", { staticClass: "time" }, [
                _vm._v("周末及节假日：9:00-18:00")
              ]),
              _vm._m(0),
              _vm._m(1),
              _c("p", [_vm._v("新明辉智慧仓储物流园-南门")]),
              _c("p")
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "about-title" }, [
      _vm._v("客服热线："),
      _c("span", [_vm._v("18669659922")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "about-title asd" }, [
      _vm._v("联系地址："),
      _c("span", [_vm._v("山东省临沂市兰山区聚财六路和临西十二路")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a606064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a606064","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/about.vue
// module id = dKKs
// module chunks = 24